export class CandidateDisplayQueryFilter {
    constructor() {
        this.searchString = "";
        this.clientOrBuList = [];
        this.status = [];
        this.requisitionStatus = [];
        this.requisitionNumbers = [];
        this.firstName = "";
        this.lastName = "";
        this.phone = "";
        this.email = "";
        this.workflowStates = [];
        this.recruiterList = [];
        this.roleList = [];
        this.workLocationIds = [];
        this.sponsorships = [];
        this.jobTypes = [];
        this.jobSubTypes = [];
        this.salary = "";
        this.rate = "";
        this.visibility = [];
        this.vendors = [];
        this.selectedFilterSort = "";
        this.showCandidateDisplayFilterIcon = true;
    }
}
//# sourceMappingURL=candidateDisplayQueryFilter.js.map